import axios from "axios"
import { env_api_url } from "../../common/Constants"

export const fetchL4MetaData=async()=>{
    const response=await axios.get(`${env_api_url}bio/v2/biomerics/l4-meta-data`)
    console.log("response in L4 page api data:", response)
    return response.data
}